import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Tooltip, TooltipProps } from '@mui/material';
import React from 'react';

type IHelpTooltipProps = Omit<TooltipProps, 'children'>;

const HelpTooltip: React.FC<IHelpTooltipProps> = (props: IHelpTooltipProps) => (
	<Tooltip {...props}>
		<HelpOutlineIcon color="disabled" fontSize="medium" />
	</Tooltip>
);

export default HelpTooltip;
